import React from 'react'
import FileUploader from "react-firebase-file-uploader";
import { withFirebase } from '../firebase'
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import modalStyle from '../styles/modal';

Modal.setAppElement('#root');
class JuntaItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            uid: this.props.item.uid,
            title: this.props.item.title,
            type: this.props.item.type,
            location: this.props.item.location,
            listing: this.props.item.listing,
            fileUrl: this.props.item.fileUrl,
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        }
    }

    handleUploadStart = () => {
        console.log("upload start");
        this.setState({
            loading: true
        });
    }

    handleUploadError = (error) => {
        this.setState({
            loading: false
        });
        this.props.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
    };

    handleUploadSuccess = filename => {
        this.setState({
            loading: false,
        });
        this.props.firebase.file('junta', filename).getDownloadURL()
            .then(fileUrl => {
                this.props.handleUploadFile(fileUrl, this.state)
                // this.setState({ avatarURL: url })
            });
    };

    showConfirmModal = (event) => {
        this.setState({
            confirm: {
                isShow: true,
                title: 'Eliminar',
                message: "Está seguro de eliminar este elemento."
            }
        });
        event.stopPropagation();
    }

    closeConfirmModal = (confirmed) => {
        this.setState({
            confirm: {
                isShow: false,
                title: '',
                message: ''
            }
        });
        if (confirmed) {
            this.props.handleDelete(this.props.item);
        }
    }

    handleEdit = () => {
        const { uid, title, type, location, listing, fileUrl } = this.state;
        this.props.handleEdit({ uid, title, type, location, listing, fileUrl });
    }

    render() {
        const { loading, title, type, location, listing, fileUrl, confirm } = this.state;

        let fileUrlText = fileUrl;
        if (fileUrl && fileUrl.length > 0) {
            let index = fileUrl.lastIndexOf("?");
            fileUrlText = fileUrl.substring(0, index);

            index = fileUrlText.lastIndexOf("/");
            fileUrlText = fileUrlText.substring(index, fileUrlText.length);
        }
        const filesRef = this.props.firebase.folder('junta');
        const fileName = title;
        const textButtom = fileUrl ? 'Modificar Archivo' : 'Seleccionar Archivo';

        return (
            <tr className="bg-hover" >
                <td className="align-middle " onClick={this.handleEdit} data-toggle="tooltip" data-placement="top" title="Editar">
                    {title}
                </td>
                <td className="align-middle text-center " onClick={this.handleEdit} data-toggle="tooltip" data-placement="top" title="Editar">
                    {type || "-"}
                </td>
                <td className="align-middle text-center bg-hover" onClick={this.handleEdit} data-toggle="tooltip" data-placement="top" title="Editar">
                    {location || "-"}
                </td>
                <td className="align-middle text-center bg-hover" onClick={this.handleEdit} data-toggle="tooltip" data-placement="top" title="Editar">
                    {listing || "-"}
                </td>

                <th className="text-nowrap align-middle">
                    {(fileUrlText) ?
                        <a target="_blank" rel="noopener noreferrer" href={fileUrl} className="card-link text-primary">
                            <FontAwesomeIcon className="mr-2" icon={faExternalLinkAlt} />
                            <small>Descargar</small>
                        </a>
                        :
                        <div className="text-break align-middle text-secondary"><small>Sin archivo</small></div>
                    }
                </th>
                <th className="align-middle" >
                    <div className="nav justify-content-end">
                        {(!loading) ?
                            <div>
                                <label className="btn btn-dark btn-sm mb-0" data-toggle="tooltip" data-placement="bottom" title={textButtom} >
                                    <FontAwesomeIcon className="" icon={faCloudUploadAlt} />
                                    <FileUploader
                                        hidden
                                        accept="application/pdf,image/*"
                                        name="file"
                                        filename={fileName}
                                        storageRef={filesRef}
                                        onUploadStart={this.handleUploadStart}
                                        onUploadError={this.handleUploadError}
                                        onUploadSuccess={this.handleUploadSuccess}
                                    />
                                </label>
                                <label onClick={this.showConfirmModal} className="btn btn-sm btn-danger ml-2 mb-0" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </label>
                            </div>
                            :
                            <div>
                                <Loader
                                    type="ThreeDots"
                                    color="#263238"
                                    height={50}
                                    width={50}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </th>
                <Modal
                    isOpen={confirm.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={() => this.closeConfirmModal(false)}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{confirm.title}</h5>
                        <p className="card-text text-break">{confirm.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={() => this.closeConfirmModal(false)} className="btn btn-sm btn-dark">No</button>
                            <button onClick={() => this.closeConfirmModal(true)} className="btn btn-sm btn-dark ml-2 pl-2 pr-2">Si</button>
                        </div>
                    </div>

                </Modal>
            </tr >
        );
    }

}
export default withFirebase(JuntaItem);